import { createContext, useContext } from "react";

export interface LaunchpadTile {
  id: string;
  title: string;
  description: string;
  path: string;
  icon?: any;
  highlight?: boolean;
}

interface LaunchpadContextValue {
  setPageTitle?: (title: string, isEditing: boolean, editedValue?: string) => void;
  setTitleHandlers?: (handlers: {
    onClick: () => void;
    onChange: (value: string) => void;
    onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    onBlur: () => void;
  }) => void;
  setCardMenuActions?: (actions: Array<{
    icon: string;
    label: string;
    onClick: () => void;
    danger?: boolean;
  }> | null) => void;
  tiles?: LaunchpadTile[];
}

export const LaunchpadContext = createContext<LaunchpadContextValue>({});

export function useLaunchpad() {
  return useContext(LaunchpadContext);
}
